import { RemoteConfigApp, remoteConfigAppTitles } from 'src/constants/remote-config/remoteConfig'
import { ADMIN_ROUTES } from 'src/constants/routes'
import type { RemoteConfigNavItem } from './remoteConfigNav.types'

export const REMOTE_CONFIG_ITEMS: RemoteConfigNavItem[] = [
  {
    app: RemoteConfigApp.Client,
    to: ADMIN_ROUTES.REMOTE_CONFIG_CLIENT_URL,
    label: remoteConfigAppTitles[RemoteConfigApp.Client],
    iconName: 'gs_driver_front',
  },
  {
    app: RemoteConfigApp.Dashboard,
    to: ADMIN_ROUTES.REMOTE_CONFIG_DASHBOARD_URL,
    label: remoteConfigAppTitles[RemoteConfigApp.Dashboard],
    iconName: 'gs_buildings',
  },
]
